import type { Components, Theme } from '@mui/material/styles';

export const MuiListItemText: Components<Theme>['MuiListItemText'] = {
  styleOverrides: {
    root: {
      margin: 0,
    },
  },
};
